/* Cambio Paese/mercato → SVUOTA il carrello prima del POST /localization.
   Replica root.tsx:132-168 dell'headless: i prodotti sono CLONI per mercato
   con profili di spedizione dedicati — righe di un altro mercato in carrello
   arriverebbero al checkout senza tariffa applicabile (vincolo Irina:
   "il cambio paese deve invalidare i prodotti non disponibili").
   Il cambio LINGUA non svuota (il live svuota solo sul segmento country).
   Listener in CAPTURE sul documento: Dawn (localization-form.js) submitta
   via form.submit() al click sull'<a data-value>, che NON emette l'evento
   submit — intercettare il click è l'unico aggancio affidabile. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest('localization-form a[data-value]');
      if (!a) return;
      var form = a.closest('form');
      var input = form && form.querySelector('input[name="country_code"]');
      if (!input) return; // selettore lingua: non svuotare
      var next = a.dataset.value;
      var current = window.Shopify && window.Shopify.country;
      if (!next || next === current) return;
      e.preventDefault();
      e.stopPropagation(); // Dawn non deve gestire questo click
      input.value = next;
      var done = false;
      var go = function () {
        if (done) return;
        done = true;
        form.submit();
      };
      // fail-open: se /cart/clear.js non risponde in 2s si cambia comunque paese
      setTimeout(go, 2000);
      fetch('/cart/clear.js', {method: 'POST'})
        .catch(function () {})
        .then(go, go);
    },
    true
  );
})();
